import { render, staticRenderFns } from "./MedicalStoresForm.vue?vue&type=template&id=79071657&"
import script from "./MedicalStoresForm.vue?vue&type=script&lang=js&"
export * from "./MedicalStoresForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalStoresForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports